import post from "../../../../api/methods/post";
import { HANDLE_JOURNEY_SUBSCRIPTION } from "../journeyEndpoints";

export const subToJourney = async (userId, journeyId) => {

    const postModel = {
        type: 'subscribe',
        journeyId: journeyId,
        userId: userId
    }

    const result = await post(HANDLE_JOURNEY_SUBSCRIPTION, postModel);
    console.log(result);

    return result;
}


